import { useEffect } from 'react';
import {
  getContentEntityStructuresLookups,
  getContentEntityTypeByIdMultilingual,
} from '@wajeez-web/stores/content';
import { Spin } from '@wajeez-web/components/ui';
import { useParams } from 'react-router-dom';
import { useGetContentEntityTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { ContentEntityTypeCreateForm } from './ContentEntityTypeCreateForm';
import { ContentEntityTypeEditForm } from './ContentEntityTypeEditForm';
import { useCommonSelector } from '@wajeez-web/stores/common';

interface ContentEntityTypeFormProps {
  type: 'Create' | 'Edit';
  onSubmit: (contentEntityTypeId: number) => void;
  onCancel: () => void;
}

export const ContentEntityTypeForm = ({
  type,
  onSubmit,
  onCancel,
}: ContentEntityTypeFormProps) => {
  const { id } = useParams<{ id: string }>();

  const languageId = useCommonSelector(
    ({ common }) => common.settings.LanguageId
  );

  const contentEntityTypeByIdMultilingual =
    useGetContentEntityTypeByIdMultilingual();

  useEffect(() => {
    if (id) {
      getContentEntityTypeByIdMultilingual(Number(id));
    }
  }, [id]);

  useEffect(() => {
    getContentEntityStructuresLookups({ languageId: languageId.toString() });
  }, [languageId]);

  return (
    <div className="relative w-[800px] mx-auto">
      {type === 'Create' ? (
        <ContentEntityTypeCreateForm onSubmit={onSubmit} onCancel={onCancel} />
      ) : contentEntityTypeByIdMultilingual.status === 'loading' ? (
        <Spin />
      ) : (
        <ContentEntityTypeEditForm onSubmit={onSubmit} onCancel={onCancel} />
      )}
    </div>
  );
};
